module.exports = __webpack_public_path__ + "static/media/sun-down.dfdbea7a.png";